// eslint-disable-next-line no-restricted-imports
import { Configuration, GetExchangePeriodResponse, DefaultApi as MarketApi } from '@eih-netbroker/api-market';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config/config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';
import { resolveResourceBasePath } from './resourceBasePath';

export type CurrencyExchangePeriodResponse = GetExchangePeriodResponse;

export class MarketResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  public static name = 'MarketResource';

  private marketApi: MarketApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    const marketBasePath = resolveResourceBasePath(basePath, configApi.usUrl.market);
    super(axiosInstance, marketBasePath, configApi);
    this.marketApi = new MarketApi(new Configuration(), marketBasePath, axiosInstance);
  }

  public async getIsCurrencyExchangeEnabled(headers: ResourceHeadersWithToken) {
    return this.marketApi.getCurrencyExchangeEnabled(headers, {
      baseURL: this.basePath,
    });
  }

  public async getActualExchangePeriod(headers: ResourceHeadersWithToken) {
    return this.marketApi.getActualExchangePeriod(headers, {
      baseURL: this.basePath,
    });
  }

  public async getNextExchangePeriod(headers: ResourceHeadersWithToken) {
    return this.marketApi.getNextExchangePeriod(headers, {
      baseURL: this.basePath,
    });
  }
}
